import Layout from '@/layout'

const newsRouter={
    path:'/plugcenters',
    component: Layout,
    redirect: '/index',
    alwaysShow: true,
    // name:'news',
    meta:{
      title:'渠道中心',
      icon: 'message',
      roles: ['admin', 'editor']
    },
    children: [
      {
        path: 'myincome',
        component: () => import('../../views/plugcenters/index.vue'),
        name: 'myplugcenter',
        meta: {
          title: '我的收入',
          roles: ['admin'] // or you can only set roles in sub nav 或者只能在子导航中设置角色
        }
      },
      {
        path: 'regionalpolicy',
        component: () => import('../../views/plugcenters/regionalpolicy.vue'),
        name: 'regionalpolicy',
        meta: {
          title: '区域代理',
          roles: ['regionalpolicy'] // or you can only set roles in sub nav 或者只能在子导航中设置角色
        }
      },
      {
        path: 'distribution',
        component: () => import('../../views/plugcenters/distribution.vue'),
        name: 'distribution',
        meta: {
          title: '分销代理',
          roles: ['distribution'] // or you can only set roles in sub nav 或者只能在子导航中设置角色
        }
      },
      {
        path: 'merchants',
        component: () => import('../../views/plugcenters/merchants.vue'),
        name: 'merchants',
        meta: {
          title: '招商代理',
          roles: ['merchants'] // or you can only set roles in sub nav 或者只能在子导航中设置角色
        }
      }
      
    ]
   
}
export default newsRouter